<template>
  <a-modal
    :title="modalTitle"
    :maskClosable="false"
    :visible="showModal"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="提交"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 企业名称 -->
      <a-form-item
        label="企业名称"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请输入企业名称' }] }
          ]"
        />
      </a-form-item>
      <!-- 联系人 -->
      <a-form-item
        label="联系人"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'contactPerson',
            { rules: [{ required: true, message: '请输入企业名称联系人' }] }
          ]"
        />
      </a-form-item>
      <!-- 联系电话 -->
      <a-form-item
        label="联系电话"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'contactPhone',
            {
              rules: [
                { required: true, message: '请输入联系电话' },
                {
                  pattern: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
                  message: '联系电话格式不正确'
                }
              ]
            }
          ]"
        />
      </a-form-item>
      <!-- id -->
      <a-form-item v-if="addInfo.id">
        <a-input type="hidden" v-decorator="['id', { rules: [] }]"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      modalTitle: '添加企业'
    }
  },
  props: {
    submitType: {
      type: String,
      default: 'add'
    },
    showModal: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    addInfo: {
      type: Object,
      default: () => {
        return {
          name: '',
          contactPerson: '',
          contactPhone: ''
        }
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('cancel')
    },
    handleOk (e) {
      this.$emit('submit', this.form)
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  watch: {
    submitType: function (data) {
      this.modalTitle = data === 'add' ? '添加企业' : '修改企业'
      setTimeout(() => {
        this.form.setFieldsValue(this.addInfo)
      }, 100)
    }
  }

}
</script>

<style lang="less" scoped></style>
